import { api } from "./api";

// MT-013 — CRUD de dominios por tenant (solo SUPER_ADMIN en el backend).

export interface TenantDomain {
  id: number;
  tenantId: string;
  domain: string;
  isPrimary: boolean;
  active: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface TenantDomainsResponse {
  isDefaultTenant: boolean;
  message?: string;
  domains: TenantDomain[];
}

export const tenantDomainsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTenantDomains: build.query<TenantDomainsResponse, string>({
      query: (tenantId) => ({ url: `/bo/tenants/${tenantId}/domains` }),
      providesTags: (result, error, tenantId) => [{ type: "tenantDomains", id: tenantId }],
    }),
    addTenantDomain: build.mutation<
      TenantDomain,
      { tenantId: string; domain: string; isPrimary?: boolean }
    >({
      query: ({ tenantId, domain, isPrimary }) => ({
        url: `/bo/tenants/${tenantId}/domains`,
        method: "POST",
        body: { domain, isPrimary },
      }),
      invalidatesTags: (result, error, { tenantId }) => [{ type: "tenantDomains", id: tenantId }],
    }),
    removeTenantDomain: build.mutation<void, { tenantId: string; domainId: number }>({
      query: ({ tenantId, domainId }) => ({
        url: `/bo/tenants/${tenantId}/domains/${domainId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { tenantId }) => [{ type: "tenantDomains", id: tenantId }],
    }),
    setPrimaryTenantDomain: build.mutation<void, { tenantId: string; domainId: number }>({
      query: ({ tenantId, domainId }) => ({
        url: `/bo/tenants/${tenantId}/domains/${domainId}/primary`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, { tenantId }) => [{ type: "tenantDomains", id: tenantId }],
    }),
  }),
});

export const {
  useGetTenantDomainsQuery,
  useAddTenantDomainMutation,
  useRemoveTenantDomainMutation,
  useSetPrimaryTenantDomainMutation,
} = tenantDomainsApi;
